import { catchRestError, RestClient } from "clients/rest";
import { UseFormReturn } from "react-hook-form";
import { mode } from "services/codes";

export type B100230CreateRequest = {
  haisorouteNo: string;
  batchNo: string;
} & Partial<{
  haisorouteNm: string;
}>;

// 登録処理
export const B100230Create = (data: B100230CreateRequest) => {
  return RestClient.post("b100230/create", data);
};

export type B100230UpdateRequest = {
  haisorouteNo: string;
  batchNo: string;
  version: number;
} & Partial<{
  haisorouteNm: string;
}>;

// 更新処理
export const B100230Update = (data: B100230UpdateRequest) => {
  return RestClient.put("b100230/update", data);
};

export type B100230DeleteRequest = {
  haisorouteNo: string;
};

// 削除処理
export const B100230Delete = (data: B100230DeleteRequest) => {
  return RestClient.delete("b100230/delete", { data: data });
};
